import React, { useEffect, useState } from 'react';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' && navigator.onLine === false,
  );

  useEffect(() => {
    const onOnline = () => setOffline(false);
    const onOffline = () => setOffline(true);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="safe-area-top border-b border-slate-300 bg-slate-100 px-4 pb-2 text-xs text-slate-700 dark:border-slate-700/60 dark:bg-slate-800/80 dark:text-slate-200"
    >
      <div className="mx-auto flex max-w-lg items-center gap-2 pt-2">
        <span aria-hidden="true">☁︎</span>
        <p className="flex-1 leading-snug">
          You&rsquo;re offline. Check-ins will sync when you&rsquo;re back online.
        </p>
      </div>
    </div>
  );
}
